import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { plansEnabled } from '../config/featureFlags';

/**
 * When plans UI is off: send employers to their dashboard; everyone else to the
 * landing #pricing section ("Free for agencies"). Avoids /employer/dashboard → /
 * bounce for anonymous visitors (ProtectedRoute).
 */
export default function PlansRouteRedirect() {
  const { user, profile, loading } = useAuth();

  if (plansEnabled()) {
    return <Navigate to="/employer/choose-plan" replace />;
  }

  if (loading) return null;

  if (user && (profile as { role?: string } | null)?.role === 'employer') {
    return <Navigate to="/employer/dashboard" replace />;
  }

  return <Navigate to="/#pricing" replace />;
}
